import React from 'react';
import { Link } from 'react-router-dom';
import { HeroStage } from '../components/HeroStage';
export function Home() {
  return <div data-id="element-174" data-mp="2neldh1qnxpqd">
      <div className="sticky top-[4.5rem] -z-0" data-id="element-175" data-mp="2ne1xhqkkpbez">
        <HeroStage data-id="element-176" data-mp="2s635v1emehzq" />
      </div>

      <section className="relative z-10 bg-ink" data-id="element-177" data-mp="2s7xqsfpw6a3t">
        <div className="mx-auto max-w-page px-6 py-14 md:px-10 md:py-20" data-id="element-178" data-mp="2x5ps20cff8ko">
          <p className="max-w-md text-sm leading-relaxed text-muted" data-id="element-179" data-mp="2x7shai5r8xoc">
            A creative experiential production studio — pop-ups, national tours,
            conferences and tradeshows, built and run end to end.
          </p>
        </div>

        <div className="mx-auto flex max-w-page flex-wrap items-center justify-between gap-4 border-t border-line px-6 py-10 text-[0.65rem] uppercase tracking-micro text-muted md:px-10" data-id="element-180" data-mp="29flotu35hau7">
          <Link to="/contact" className="transition-colors hover:text-lilac" data-id="element-181" data-mp="3kvk3cdh3kp2t">
            Start a project
          </Link>
          <a href="mailto:info@heybreezy.co" className="transition-colors hover:text-lilac" data-id="element-182" data-mp="3ovuc1xw9xtld">
            info@heybreezy.co
          </a>
          <span data-id="element-183" data-mp="2vxyc0p4us8fw">© {new Date().getFullYear()} Breezy Experiential</span>
        </div>
      </section>
    </div>;
}